(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class TstHeaderPredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = null;
      this.results = null;
      this.body = null;
      this.form = null;
      this.abortController = null;
      this.timer = null;
      this.cache = new Map();
      this.activeIndex = -1;
      this.lastTerm = '';
    }

    connectedCallback() {
      if (this.dataset.tstReady === 'true') return;
      this.dataset.tstReady = 'true';
      this.input = this.querySelector('.tst-header-search-input');
      this.results = this.querySelector('[data-tst-predictive-results]');
      this.body = this.querySelector('[data-tst-predictive-body]');
      this.form = this.querySelector('.tst-header-search-form');
      if (!this.input || !this.results || !this.body || !this.form) return;

      this.input.addEventListener('input', () => this.queueSearch());
      this.input.addEventListener('focus', () => this.onFocus());
      this.input.addEventListener('keydown', (event) => this.onKeydown(event));
      this.form.addEventListener('submit', (event) => this.onSubmit(event));
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) this.close();
      });
    }

    queueSearch() {
      window.clearTimeout(this.timer);
      const term = this.input.value.trim();
      if (!term.length) {
        this.lastTerm = '';
        this.close();
        return;
      }
      this.timer = window.setTimeout(() => this.search(term), 220);
    }

    onFocus() {
      const term = this.input.value.trim();
      if (!term.length) return;
      if (term === this.lastTerm && this.body.children.length) {
        this.open();
      } else {
        this.queueSearch();
      }
    }

    onSubmit(event) {
      const links = this.getNavigableLinks();
      if (this.activeIndex >= 0 && links[this.activeIndex]) {
        event.preventDefault();
        window.location.href = links[this.activeIndex].href;
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        this.input.focus();
        return;
      }

      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const links = this.getNavigableLinks();
      if (!links.length) return;
      event.preventDefault();
      if (this.results.hidden) this.open();

      if (event.key === 'ArrowDown') {
        this.activeIndex = this.activeIndex >= links.length - 1 ? 0 : this.activeIndex + 1;
      } else {
        this.activeIndex = this.activeIndex <= 0 ? links.length - 1 : this.activeIndex - 1;
      }

      links.forEach((link, index) => link.classList.toggle('tst-is-active', index === this.activeIndex));
      links[this.activeIndex].scrollIntoView({ block: 'nearest' });
    }

    getNavigableLinks() {
      return Array.from(this.results.querySelectorAll('a[href]'));
    }

    async search(term) {
      if (!term.length) return;
      this.abortController?.abort();
      this.abortController = new AbortController();
      this.activeIndex = -1;
      this.lastTerm = term;

      if (this.cache.has(term)) {
        this.render(term, this.cache.get(term));
        return;
      }

      this.showState('Searching…');

      try {
        const url = new URL(this.dataset.predictiveUrl, window.location.origin);
        url.searchParams.set('q', term);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', this.dataset.limit || '6');
        url.searchParams.set('resources[options][unavailable_products]', 'last');
        url.searchParams.set('section_id', 'predictive-search');

        const response = await fetch(url.toString(), { signal: this.abortController.signal });
        if (!response.ok) throw new Error(String(response.status));
        const html = await response.text();
        const documentResult = new DOMParser().parseFromString(html, 'text/html');
        const productList = documentResult.querySelector('#predictive-search-results-products-list');
        const markup = productList ? productList.innerHTML : '';
        this.cache.set(term, markup);
        if (this.input.value.trim() !== term) return;
        this.render(term, markup);
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (this.input.value.trim() !== term) return;
        this.showState('No matching products found.');
      }
    }

    render(term, markup) {
      this.body.innerHTML = '';

      if (!markup.trim()) {
        this.showState('No matching products found.');
        return;
      }

      const heading = document.createElement('p');
      heading.className = 'tst-header-search-results-heading';
      heading.textContent = 'Products';

      const list = document.createElement('ul');
      list.className = 'tst-header-search-results-list';
      list.innerHTML = markup;
      list.querySelectorAll('a').forEach((link) => link.removeAttribute('tabindex'));

      const viewAll = document.createElement('a');
      viewAll.className = 'tst-header-search-view-all';
      const searchUrl = new URL(this.dataset.searchUrl, window.location.origin);
      searchUrl.searchParams.set('q', term);
      searchUrl.searchParams.set('options[prefix]', 'last');
      viewAll.href = searchUrl.toString();
      viewAll.textContent = `View all results for “${term}”`;

      this.body.append(heading, list, viewAll);
      this.open();
    }

    showState(message) {
      this.body.innerHTML = '';
      const state = document.createElement('div');
      state.className = 'tst-header-search-state';
      state.textContent = message;
      this.body.appendChild(state);
      this.open();
    }

    open() {
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.results.hidden = true;
      this.input.setAttribute('aria-expanded', 'false');
      this.activeIndex = -1;
      this.getNavigableLinks().forEach((link) => link.classList.remove('tst-is-active'));
    }
  }

  if (!customElements.get('tst-header-predictive-search')) {
    customElements.define('tst-header-predictive-search', TstHeaderPredictiveSearch);
  }

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
